module.exports = __webpack_public_path__ + "img/67.f78c113b.png";